import { useContext, useMemo, memo } from 'react';
import { LuzmoDashboardComponent } from '@luzmo/react-embed';

import DashboardContext from './DashboardContext';
import { IDashboard } from './interfaces';

const appServer = 'https://app.us.luzmo.com';
const apiHost = 'https://api.us.luzmo.com';

const DashboardComponent = memo(
  ({
    tabs,
    selectedDashboard,
  }: {
    tabs: IDashboard[];
    selectedDashboard: string;
  }) => {
    if (!tabs || !selectedDashboard) {
      return null;
    }

    return (
      <LuzmoDashboardComponent
        dashboardId={tabs.find((d) => d.slug === selectedDashboard).dashboardId}
        appServer={appServer}
        apiHost={apiHost}
      />
    );
  },
);

export default function Dashboard() {
  const context = useContext(DashboardContext);

  return (
    <DashboardComponent
      tabs={context.tabs}
      selectedDashboard={context.selectedDashboard}
    />
  );
}
